import { Component } from "@angular/core";
import { SvgIcon } from "@ponder-shared/utils/svgIcons";
import { SidebarButtonLinkComponent } from "./sidebar-button-link.component";

@Component({
    selector: "sidebar-support",
    imports: [],
    templateUrl: "./sidebar-button-link.component.html"
})
export class SidebarSupportButtonComponent extends SidebarButtonLinkComponent {
    public constructor() { super("Support", SvgIcon.Support, "/about#contact", false); }
}